/*
 * tc-cookie-consent.js
 * Drives the cookie banner and preferences dialog in snippets/tc-cookie-consent.liquid
 * through Shopify's Customer Privacy API.
 */
(function () {
  var root = document.querySelector('[data-tc-cookie]');
  if (!root) return;

  var banner = root.querySelector('[data-tc-cookie-banner]');
  var dialog = root.querySelector('[data-tc-cookie-dialog]');
  var scrim = root.querySelector('[data-tc-cookie-scrim]');
  var prefs = Array.prototype.slice.call(root.querySelectorAll('[data-tc-cookie-pref]'));
  var html = document.documentElement;
  var FORCE_KEY = 'tc_cookie_force';
  var lastFocus = null;

  function forced() {
    try {
      var q = (location.search.match(/[?&]cookie_banner=([^&]*)/) || [])[1];
      if (q === 'off') sessionStorage.removeItem(FORCE_KEY);
      else if (q === '1') sessionStorage.setItem(FORCE_KEY, '1');
      return sessionStorage.getItem(FORCE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function withPrivacy(cb) {
    if (privacy()) return cb(privacy());
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error && privacy()) cb(privacy());
    });
  }

  function syncRoot() {
    var open = !banner.hidden || !dialog.hidden;
    root.hidden = !open;
    html.classList.toggle('tc-cookie-active', open);
  }

  function showBanner() {
    banner.hidden = false;
    syncRoot();
  }

  function hideAll() {
    banner.hidden = true;
    closeDialog(false);
    syncRoot();
  }

  function fillFromConsent() {
    var current = {};
    try {
      current = (privacy() && privacy().currentVisitorConsent && privacy().currentVisitorConsent()) || {};
    } catch (e) {}
    prefs.forEach(function (input) {
      input.checked = current[input.getAttribute('data-tc-cookie-pref')] === 'yes';
    });
  }

  function focusable() {
    return Array.prototype.slice.call(dialog.querySelectorAll('button, [href], input')).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDialog(true);
      return;
    }
    if (e.key !== 'Tab') return;
    var els = focusable();
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDialog(trigger) {
    lastFocus = trigger || document.activeElement;
    withPrivacy(fillFromConsent);
    fillFromConsent();
    dialog.hidden = false;
    scrim.hidden = false;
    syncRoot();
    document.addEventListener('keydown', onKey);
    dialog.focus();
  }

  function closeDialog(restoreFocus) {
    if (dialog.hidden) return;
    dialog.hidden = true;
    scrim.hidden = true;
    document.removeEventListener('keydown', onKey);
    syncRoot();
    if (restoreFocus && lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }

  function save(consent) {
    hideAll();
    withPrivacy(function (cp) {
      cp.setTrackingConsent(consent, function () {});
    });
  }

  function all(value) {
    return { analytics: value, marketing: value, preferences: value, sale_of_data: value };
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-tc-cookie-accept')) save(all(true));
    else if (t.hasAttribute('data-tc-cookie-reject')) save(all(false));
    else if (t.hasAttribute('data-tc-cookie-open')) openDialog(t);
    else if (t.hasAttribute('data-tc-cookie-close')) closeDialog(true);
    else if (t.hasAttribute('data-tc-cookie-all')) {
      var on = t.getAttribute('data-tc-cookie-all') === 'true';
      prefs.forEach(function (input) {
        input.checked = on;
      });
    } else if (t.hasAttribute('data-tc-cookie-save')) {
      var c = {};
      prefs.forEach(function (input) {
        c[input.getAttribute('data-tc-cookie-pref')] = input.checked;
      });
      c.sale_of_data = c.marketing;
      save(c);
    }
  });

  scrim.addEventListener('click', function () {
    closeDialog(true);
  });

  /* Links elsewhere on the page (e.g. a footer "Cookie preferences") can reopen the dialog. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tc-cookie-open]');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    openDialog(t);
  });

  /* shouldShowBanner() only says this region needs a banner; it stays true after the
     visitor has chosen. Shopify's own banner also requires that no choice is on record,
     so ours does too, or it comes back on every page after Accept all.
     sale_of_data is left out: Shopify sets it to "no" by itself when the browser sends
     Global Privacy Control (Firefox private windows do), before any choice is made.
     Counting it hid the banner from those visitors entirely (seen from AU, 2026-10-14). */
  function undecided(cp) {
    var c = {};
    try {
      c = (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
    } catch (e) {}
    return !['analytics', 'marketing', 'preferences'].some(function (k) {
      return c[k] === 'yes' || c[k] === 'no';
    });
  }

  var force = forced();
  withPrivacy(function (cp) {
    if (force || (cp.shouldShowBanner && cp.shouldShowBanner() && undecided(cp))) showBanner();
  });
  if (force && !window.Shopify) showBanner();

  /* Mirror Shopify's own banner: its script decides who is asked and when (its admin
     regions, the first page of a visit included, and always in theme preview mode while
     the preview bar is showing). It inserts #shopify-pc__banner and shows it by setting
     style.display = 'block'; ours shows at that moment unless a choice is on record.
     The CSS keeps theirs hidden while this script runs. Watched for the whole page view,
     with no time limit: on the first page of a visit Shopify can decide after this script
     has run (first pages were missed from UK/AU on a phone, 2026-10-15). */
  html.classList.add('tc-cookie-managed');
  var watched = null;
  var bannerWatcher = new MutationObserver(checkShopifyBanner);
  function checkShopifyBanner() {
    var theirs = document.getElementById('shopify-pc__banner');
    if (theirs !== watched) {
      bannerWatcher.disconnect();
      watched = theirs;
      if (theirs) bannerWatcher.observe(theirs, { attributes: true, attributeFilter: ['style'] });
    }
    if (!theirs || theirs.style.display !== 'block') return;
    if (privacy() && !undecided(privacy())) return;
    showBanner();
  }
  checkShopifyBanner();
  // Shopify inserts its banner as a direct child of <body>.
  new MutationObserver(checkShopifyBanner).observe(document.body, { childList: true });
})();
